/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventcoverchatopen3Inputs */

const en_eventcoverchatopen3 = /** @type {(inputs: Eventcoverchatopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design a cover`)
};

const de_eventcoverchatopen3 = /** @type {(inputs: Eventcoverchatopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover gestalten`)
};

/**
* | output |
* | --- |
* | "Design a cover" |
*
* @param {Eventcoverchatopen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventcoverchatopen3 = /** @type {((inputs?: Eventcoverchatopen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventcoverchatopen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventcoverchatopen3(inputs)
	return de_eventcoverchatopen3(inputs)
});
export { eventcoverchatopen3 as "eventCoverChatOpen" }